import React from "react";
import { withNavBars } from "../../HOCs";
import DeliveryMilestoneMaster from "./deliveryMilestoneMaster";

class DeliveryMilestoneMasterParent extends React.Component {
    render() {
        return <DeliveryMilestoneMaster  {...this.props} />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(DeliveryMilestoneMasterParent, props);
